export const userProfile = {
  user_personalInformation: "My persoonlike inligting",
  user_alias: "Alias",
  user_alias_edit: "Wysig alias",
  user_alias_placeholder: "Kies jou alias",
  user_alias_save: "Stoor",
  user_alias_cancel: "Kanselleer",
  user_alias_saving: "Stoor...",
  user_alias_success: "Alias opgedateer",
  user_alias_error: "Kon nie alias opdateer nie",
  user_alias_unavailable: "Hierdie alias is reeds in gebruik",
  user_alias_checking: "Kontroleer...",
  user_alias_available: "Beskikbaar",
  user_alias_min_length: "Minimum 3 karakters",
  user_name: "Naam",
  user_lastName: "Van",
  user_email: "E-pos",
  user_phoneNumber: "Foonnommer",
  user_birthdate: "Geboortedatum",
  user_national_id: "ID-nommer",
  user_state: "Staat",
  user_city: "Stad",
  user_support_message: "Om enige veranderings of opdaterings aan jou profiel te maak, kontak asseblief ons",
  user_support_link: "tegniese ondersteuning",

  userProfileImageFormat: "Onondersteunde formaat",
  userProfileImageFormatDesc: "Slegs JPEG-, JPG- of PNG-beelde word toegelaat.",
  userProfileImageSize: "Beeld te groot",
  userProfileImageSizeDesc: "Die maksimum toegelate grootte is 3MB.",
  userProfileImageEdit: "Wysig",

  profileFollowers: "Volgers",
  profileFollowing: "Volg",
  profileFavoriteGames: "Gunsteling speletjies",
  profileRecentGames: "Onlangse speletjies",
  profileFavoriteProviders: "Gevolgde verskaffers",
  profileEditProfile: "Wysig profiel",
  profileKeepPlaying: "Hou aan speel",
  profileFollow: "Volg",
  profileNoFavorites: "Nog geen gunsteling speletjies nie",
  profileNoFavoritesDesc: "Speletjies wat jy as gunstelinge merk, sal hier verskyn",
  profileNoRecentGames: "Geen onlangse speletjies nie",
  profileNoRecentGamesDesc: "Speletjies wat jy speel, sal hier verskyn",
  profileNoProviders: "Jy volg nog geen verskaffers nie",
  profileGamesCount: "{{count}} speletjies",

  profileHighlightBigWins: "Groot winste",
  profileHighlightFavorites: "Gunstelinge",
  profileHighlightRecent: "Onlangs",
  profileHighlightAchievements: "My prestasies",
  profileHighlightLatestWinners: "Jongste wenners",
  profileHighlightPopularGames: "Gewilde speletjies",
  profileHighlightLastPlayed: "Laas gespeel",
  profileHighlightNoWins: "Nog geen groot winste aangeteken nie",

  profileFeedTabs: "Profielstroom-oortjies",
  profileNoBigWins: "Nog geen groot winste nie",
  profileNoBigWinsDesc: "Jou wenoomblikke sal hier verskyn",

  profileAchievementsSections: "Prestasie-afdelings",
  profileAchievementsHome: "Tuis",
  profileAchievementsMissions: "Sendinge",
  profileAchievementsEmptyHome: "Niks om te wys nie",
  profileAchievementsRank: "Rang",
  profileAchievementsXpPoints: "XP-punte",
  profileAchievementsMyRewards: "My belonings",
  profileAchievementsActiveMissions: "Aktiewe sendinge",
  profileAchievementsSeeAll: "Sien alles",
  profileAchievementsInProgress: "Aan die gang",
  profileAchievementsLive: "Lewendig",
  profileAchievementsPlayNow: "Speel nou",
  profileAchievementsDurationDays: "{{count}} dae",
  profileAchievementsTournamentType_most_points: "Meeste punte",
  profileAchievementsTournamentType_highest_win_multiplier: "Hoogste wen",
  profileAchievementsEligibility_all: "Almal",
  profileAchievementsEligibility_ranks: "Ranglyste",
  profileAchievementsEligibility_segment: "Segment",
  profileAchievementsTournamentStatus_scheduled: "Geskeduleer",
  profileAchievementsTournamentStatus_ended: "Geëindig",
  profileAchievementsTournaments: "Toernooie",
  profileAchievementsShop: "Winkel",
  profileAchievementsBoosters: "Boosters",
  profileAchievementsRewards: "Belonings",
  profileAchievementsDisabled: "Gamifikasie is nie beskikbaar nie",
  profileAchievementsEmptyMissions: "Geen aktiewe sendinge",
  profileAchievementsEmptyTournaments: "Geen toernooie beskikbaar",
  profileAchievementsEmptyShop: "Die winkel is voorlopig leeg",
  profileAchievementsEmptyBoosters: "Geen aktiewe boosters",
  profileAchievementsEmptyRewards: "Geen hangende belonings",
  profileAchievementsJoined: "Aangesluit",
  profileAchievementsOptInRequired: "Inskrywing word vereis",
  profileAchievementsStock: "{{count}} beskikbaar",
  profileAchievementsBooster_level: "Vlakbooster",
  profileAchievementsBooster_token: "Tokenbooster",
  profileAchievementsBooster_mission: "Sendingbooster",
  profileAchievementsBoostersTile: "Boosters",
  profileAchievementsMyBoosters: "My boosters",
  profileAchievementsEmptyBoostersModal: "Geen boosters beskikbaar",
  profileAchievementsEasterEgg_pending: "Vind",
  profileAchievementsEasterEgg_claimable: "Eis",
  profileAchievementsEasterEgg_claimed: "Geëis",
  profileAchievementsEasterEggTitle: "Easter egg",
  profileAchievementsEasterEggOhNo: "Ag nee!",
  profileAchievementsEasterEggPendingBody:
    "Jammer, hierdie Easter egg kan nog nie geëis word nie. Voltooi meer sendinge en probeer later weer.",
  profileAchievementsEasterEggReady: "Gereed!",
  profileAchievementsEasterEggReadyBody: "Jy kan hierdie Easter egg nou eis.",
  profileAchievementsEasterEggKeepPlaying: "Hou aan speel",
  profileAchievementsEasterEggClaiming: "Eis tans…",
  profileAchievementsEasterEggClaimError: "Kon nie eis nie. Probeer later weer.",
  profileAchievementsMissionTitle: "Sending",
  profileAchievementsEndsIn: "Eindig oor: {{time}}",
  profileAchievementsMissionRewards: "Sendingbelonings",
  profileAchievementsMissionRewardsHint: "Voltooi alle sendinge om hierdie eksklusiewe kis te ontsluit.",
  profileAchievementsObjectives: "Doelwitte",
  profileAchievementsObjectivesCount: "{{count}} doelwitte",
  profileAchievementsTerms: "Bepalings en voorwaardes",
  profileAchievementsTermsEmpty: "Geen bepalings is vir hierdie sending beskikbaar nie.",
  profileAchievementsTournamentGames: "Toernooispeletjies",
  profileAchievementsSearch: "Soek",
  profileAchievementsAll: "Almal",
  profileAchievementsNoGamesFound: "Geen speletjies gevind nie",
  profileAchievementsNoGamesFoundHint:
    "Ons het geen speletjies gevind wat by jou soektog pas nie. Probeer om die filters aan te pas of verken ons volledige versameling.",
  profileAchievementsProductDetails: "Produkbesonderhede",
  profileAchievementsLowStock: "Lae voorraad",
  profileAchievementsStockLeft: "Slegs {{count}} oor in voorraad",
  profileAchievementsBuyNow: "Koop nou",
  profileAchievementsBuying: "Koop tans…",
  profileAchievementsNotEnoughTokens: "Jy het nie genoeg tokens om hierdie produk te koop nie",
  profileAchievementsBuyError: "Kon nie die aankoop voltooi nie. Probeer later weer.",
  profileAchievementsSoldOut: "Uitverkoop",

  profileNoFollowers: "Nog geen volgers nie",
  profileNoFollowing: "Volg nog niemand nie",
  profileFollowersSoon: "Hierdie kenmerk sal binnekort beskikbaar wees",

  friendAddFriend: "Volg",
  friendStatusPending: "Versoek gestuur",
  friendStatusFriends: "Vriende",
  friendRequestSentToast: "Vriendskapsversoek gestuur",
  friendRequestSentTitle: "Versoek gestuur",
  friendRequestSentBody: "Jou vriendskapsversoek is gestuur",
  friendRequestReceivedTitle: "Vriendskapsversoek",
  friendRequestReceivedBody: "{{alias}} het vir jou 'n vriendskapsversoek gestuur",
  friendUnfriendTitle: "Ontvriend?",
  friendUnfriendDescription: "Wil jy @{{alias}} ontvriend?",
  friendUnfriendConfirm: "Bevestig",
  friendUnfriendCancel: "Kanselleer",
  friendUnfriendLoading: "Verwyder...",
};
